import { faDesktopAlt, faMobileAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { VFC } from 'react';

interface IProps {
    terminalName: string;
    isVirtual: boolean;
}

const TerminalNameCell: VFC<IProps> = ({ terminalName, isVirtual }) => {
    const ReturnDeviceIcon = (): JSX.Element => {
        if (isVirtual) {
            return (
                <td>
                    <FontAwesomeIcon icon={faMobileAlt} /> {terminalName}
                </td>
            );
        } else {
            return (
                <td>
                    <FontAwesomeIcon icon={faDesktopAlt} /> {terminalName}
                </td>
            );
        }
    };

    return ReturnDeviceIcon();
};

export default TerminalNameCell;
